import { Navigate } from 'react-router-dom';

import { useUserStore } from '@/stores/user.store';
import { getWorkspaceRoute } from '@/utils/routes';

export default function WorkspaceRedirect() {
  const { org } = useUserStore();

  if (!org?.workspaceId) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={getWorkspaceRoute(`/dashboard`)} replace />;
}
